import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderEmitter: Subject<any> = new Subject();

  constructor() {
  }

  /* Observable de eventos de loader */
  awaitLoader(): any {
    return this.loaderEmitter.asObservable();
  }

  /* Emitir evento para mostrar loader */
  showLoader(): any {
    this.loaderEmitter.next(true);
  }

  /* Emitir evento para ocultar loader */
  hideLoader(): any {
    this.loaderEmitter.next(false);
  }
}
